import { ChevronLeft, ChevronRight, Pause, Play } from "lucide-react";
import { useEffect, useState } from "react";

export const HeroCarousel = ({ slides, headline = "", intro = "" }) => {
  const [i, setI] = useState(0);
  const [playing, setPlaying] = useState(true);
  const n = slides.length;
  const s = slides[i % n];
  useEffect(() => {
    if (!playing || n < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), 5500);
    return () => clearInterval(t);
  }, [playing, n]);
  return (
    <section className="relative min-h-[560px] overflow-hidden bg-shade sm:min-h-[620px]" data-testid="hero-carousel">
      {slides.map((sl, k) => (
        <img key={k} src={sl.image} alt={sl.caption}
          className={`absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-[1400ms] ${k === i % n ? "scale-100 opacity-100" : "scale-105 opacity-0"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-shade/80 via-shade/40 to-transparent" />
      <div className="container-x relative flex min-h-[560px] flex-col justify-center pb-36 pt-16 sm:min-h-[620px]">
        <p className="eyebrow !text-gold" data-testid="hero-subtitle">{s.subtitle}</p>
        <h1 key={i} className="mt-4 max-w-3xl animate-rise font-serif text-4xl leading-[1.05] text-paper sm:text-6xl lg:text-7xl" data-testid="hero-caption">
          {headline || s.caption}
        </h1>
        {intro && <p className="mt-5 max-w-2xl whitespace-pre-line leading-relaxed text-paper/85" data-testid="hero-intro">{intro}</p>}
        <div className="mt-8 flex items-center gap-3 text-paper">
          <button onClick={() => setI((i - 1 + n) % n)} className="hero-ctrl" data-testid="hero-prev"><ChevronLeft className="h-4 w-4" /></button>
          <button onClick={() => setPlaying((p) => !p)} className="hero-ctrl" data-testid="hero-play-toggle">{playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}</button>
          <button onClick={() => setI((i + 1) % n)} className="hero-ctrl" data-testid="hero-next"><ChevronRight className="h-4 w-4" /></button>
          <span className="ml-2 font-mono text-xs tracking-[0.2em]" data-testid="hero-counter">{String(i + 1).padStart(2, "0")} / {String(n).padStart(2, "0")}</span>
        </div>
      </div>
    </section>
  );
};
